import React, {useState } from "react";
import { Button, Modal, TextField } from "@mui/material";
import { Box } from "@mui/system";
import style from "./game.module.css";
import { updateCurrentActiveWordCall } from "../../apis/admins";
import { Toast } from "../../components/alert";
import { modalStyle } from "../../components/constants";

const AddGameDefinationModal = (props) => {
  const {modalOpen, handleClose, handleChange, words, getAllGameWordList } = props
  const [isSubmit, setIsSubmit] = useState(false);

  const handleGetWord = (e) => {
        const wordVal = e?.target?.value;
        handleChange({...words, definition: wordVal });
    };

  const handleSubmitForm = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {
            const apiBody = {definition : words.definition,
                _method : "PUT"}
            const response = await updateCurrentActiveWordCall(words.id,apiBody);
            if (response) {
              const toastMessage = "your word definition added successfully!";
                Toast("success", toastMessage);
                handleChange({});
                setIsSubmit(false);
                getAllGameWordList();
            }
        } catch (error) {
            console.log(error);
        } finally {
          handleClose();
        }
    };

  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        handleClose();
      }}
    >
      <Box sx={modalStyle}>
      <form className={style.formBox} onSubmit={handleSubmitForm}>
            <h2>Add Your Word Definition</h2>
            <TextField
                type="text"
                placeholder="Add Here..."
                size="small"
                fullWidth
                value={words.definition}
                onChange={handleGetWord}
                helperText={words.length > 80 ? "You can enter 80 character maximum" : null}
                inputProps={{
                  maxLength:'80'
                }}
            />
            <Box className={style.btnBox}>
                {<Button
                    variant="outlined"  
                    color="secondary"
                    fullWidth
                    onClick={handleClose}
                    style={{ border: "1px solid #c84b96", color: "#c84b96" }}
                >
                    Cancel
                </Button>}
                <Button
                    variant="contained"
                    color="secondary"
                    sx={{ background: "#c84b96" }}
                    type="submit"
                    fullWidth
                    disabled={words.length < 5 || isSubmit ? true : false}
                >
                    {words.definition === "" ? "Add" : "Update" }
                </Button>
            </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default AddGameDefinationModal;

const titleStyles = { color: "#151E24", fontSize: 20, fontWeight: 700 };

const confirmButtonStyles = {
  width: "200px",
  textTransform: "none",
  height: 55,
  fontSize: 15,
  fontWeight: 600,
  background: "#C84B96",
  color: "#FFFFFF",
  borderRadius: 8,
  marginLeft: "auto",
};

const cancelButtonStyles = {
  width: "130px",
  height: 55,
  fontSize: 15,
  fontWeight: 600,
  color: "#313137",
  borderColor: "#313137",
  borderRadius: 8,
  textTransform: "none",
};
